module.exports = __webpack_public_path__ + "a134256d4cd3e1f2e16a89ebb03c3d96.svg";